import {injectable} from "inversify";
import {CanNegotiateInterface, CanStartNegotiateInterface} from "@/modules/diplomacy/interfaces";
import {Team} from "@/modules/team/entity";
import {Negotiation} from "@/modules/diplomacy/entity";

@injectable()
export abstract class AbstractNegotiationStarter {
  protected abstract make(target: CanNegotiateInterface): Negotiation;

  public async getNegotiation(team: Team, target: CanStartNegotiateInterface) {
    await target.load('negotiations');

    for (const n of target.negotiations) {
      await n.load('team');

      if (team.equals(n.team)) {
        return n;
      }
    }

    return null;
  }

  public async canNegotiation(team: Team, target: CanStartNegotiateInterface): Promise<boolean> {
    return await this.getNegotiation(team, target) === null;
  }

  public async start(team: Team, target: CanNegotiateInterface & CanStartNegotiateInterface) {
    if (!await this.canNegotiation(team, target)) {
      throw 'Can not start negotiation.';
    }

    const negotiation = this.make(target);
    negotiation.team = team;

    // todo: use config for param range
    if (team.user) {
      negotiation.monthlyFrom = Math.round((target.baseMonthlyPrice ?? 0) * (target.greediness / 100) * 1.3);
      negotiation.monthlyTo = Math.round((target.baseMonthlyPrice ?? 0) * (target.greediness / 100) * .7);

      negotiation.onceFrom = Math.round((target.baseOncePrice ?? 0) * (target.greediness / 100) * 1.3);
      negotiation.onceTo = Math.round((target.baseOncePrice ?? 0) * (target.greediness / 100) * .7);
    } else {
      negotiation.monthlyFrom = Math.round((target.baseMonthlyPrice ?? 0) * (target.greediness / 100) * .7);
      negotiation.monthlyTo = Math.round((target.baseMonthlyPrice ?? 0) * (target.greediness / 100) * 1.3);

      negotiation.onceFrom = Math.round((target.baseOncePrice ?? 0) * (target.greediness / 100) * .7);
      negotiation.onceTo = Math.round((target.baseOncePrice ?? 0) * (target.greediness / 100) * 1.3);
    }

    await negotiation.save();

    return negotiation;
  }
}